import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { appendOnboarding } from '../../../../features/session/sessionSlice'
import { STEP_DICTIONARY_TPL } from '../../../utils/common'
import SkeletonStepIcon from './SkeletonStepIcon'

function OnboardingStepHeader({ showTitle=true}){
    const dispatch = useDispatch()

    const [stepDictionary, setStepDictionary] = useState(STEP_DICTIONARY_TPL)
    const [loadingScreen, setLoadingScreen] = useState(true)

    const model = useSelector(state => state.site.model)
    const onboardingState = useSelector(state => state.session.onboarding)

    useEffect(() => {
        const currentSite = model?.sites?.length > 0 ? model?.sites[model?.siteActiveIdx] : {}

        if(currentSite){
            if(currentSite?.attr?.expediteOnboarding){
                setStepDictionary(prev => ({
                    ...prev,
                    step2: {
                        ...prev.step2,
                        disabled: true
                    },
                    step5: {
                        ...prev.step5,
                        disabled: true
                    },
                    step6: {
                        disabled: true,
                        step: 6,
                        icon: <i class="fas fa-question fa-1-5"></i>,
                        title: <>Questions</>,
                        stepTitle: "Some dashboard questions for you"
                    },
                    step7: {
                        disabled: true,
                        step: 7,
                        icon: null,
                        title: "",
                        stepTitle: ""                        
                    },
                    step8: {
                        step: 8,
                        icon: null,
                        title: "",
                        stepTitle: ""
                    }
                }))
            } else {
                setLoadingScreen(false)
            }
        }

    }, [model])

    useEffect(() => {
        if(stepDictionary !== STEP_DICTIONARY_TPL){
            setLoadingScreen(false)
        }
    }, [stepDictionary])

    const site = model?.sites?.length > 0 && model.siteActiveIdx !== -1 ? model.sites[model.siteActiveIdx] : {}

    return <>
    <div className="card pt-4 pb-4 pl-0 pr-0 bg-white m-0">
        <div class="row no-gutters">
            <div class="col-md-6 ml-auto mr-auto">
                <div class="d-flex justify-content-around step-crumbs">
                    {loadingScreen ? <>
                        <SkeletonStepIcon />
                        <i className={`text-center divider align-self-center`}></i>
                        <SkeletonStepIcon />
                        <i className={`text-center divider align-self-center`}></i>
                        <SkeletonStepIcon />
                        <i className={`text-center divider align-self-center`}></i>
                        <SkeletonStepIcon />
                    </> : Object.keys(stepDictionary)
                    .filter(k => ((!site?.attr?.expediteOnboarding && stepDictionary[k].step <= 4) || (site?.attr?.expediteOnboarding && stepDictionary[k].step <= 4)) && !stepDictionary[k].disabled)
                    .map((key, index) => <>
                        <div className={`text-center font-weight-bold ${stepDictionary[key].step === onboardingState.step ? "text-primary": ""}`}>
                            <button 
                                className={`btn btn-lg ${stepDictionary[key].step === onboardingState.step ? "btn-outline-primary" : "btn-default"} ${stepDictionary[key].step < onboardingState.step ? "btn-success" : ""} btn-floating btn-block mx-auto`} 
                                style={{
                                    padding: "14px 8px",
                                    opacity: "1"
                                }} 
                                disabled={onboardingState.step === 5 || (stepDictionary[key].step <= 1 && onboardingState.step > 1)}
                                onClick={() => {
                                    if(onboardingState.step > stepDictionary[key].step){
                                        dispatch(appendOnboarding({
                                            step: stepDictionary[key].step
                                        }))
                                    }
                                }}
                            >{stepDictionary[key].icon}</button>
                            {stepDictionary[key].title}
                        </div>
                        {(!site?.attr?.expediteOnboarding && stepDictionary[key].step <= 3) || (site?.attr?.expediteOnboarding && stepDictionary[key].step <= 3) ? 
                            <i className={`text-center divider align-self-center ${stepDictionary[key].step < onboardingState.step ? "text-green" : ""}`}></i> : <></>}
                    </>)}
                </div>
            </div>
        </div>
    </div>
    {showTitle && <div class="d-flex justify-content-around mb-3 mt-4">
        <h2 className="font-weight-bold pl-2 pr-2">{stepDictionary[`step${onboardingState.step}`].stepTitle}</h2>
    </div>}
    </>
}

export default OnboardingStepHeader